<script setup>
import StartConversation from './StartConversation'
import ChatConversations from './ChatConversations'

defineProps({
    authUser: Object
})
</script>

<template>
    <div class="flex items-center justify-between">
        <div>
            <h1 class="font-bold text-blue-dark mb-2">Inbox</h1>
            <p class="text-base sm:text-normal text-gray-darkest">Your inbox with messages</p>
        </div>
        <StartConversation />
    </div>

    <ChatConversations :auth-user="authUser"/>
</template>